import { Component, Input, Output, EventEmitter } from '@angular/core';
import {EventLoggerService} from '@services/event-logger-service';

@Component({
  selector: 'app-voice-note-banner-script',
  templateUrl: './voice-note-script.component.html',
  styleUrls: ['../../../user/user-view/user-home/user-home.scss'],
  standalone: false,
})
export class VoiceNoteScriptComponent {
    @Input('productsInCart') productsInCart:any;
    @Input('user') user:any;
    @Input('userDrImage') userDrImage: string;
    @Input('trackEventAudio') trackEventAudio: any;
    @Output('emitTrackEvent') emitTrackEvent:EventEmitter<any> = new EventEmitter();
    @Output('goToCart') goToCart:EventEmitter<void> = new EventEmitter();

  constructor(
    private readonly eventLogger: EventLoggerService,
  ) {
  }

    handleClick():void {
      this.goToCart.emit();
      this.eventLogger.cleverTapEvent('Buy_Now_Cart_banner_HP_clicked', JSON.stringify({ type: 'doctor_added_single_voice_note' }));
    }
    handleClickOne(event:any):void {
      this.emitTrackEvent.emit(event);
    }
}
